import { Badge } from '@zenchef/ds-react'
import { JsxStyleProps } from '@zenchef/styled-system/types'

const Subtitle = ({ children, ...props }: { children: React.ReactNode } & JsxStyleProps) => {
  return (
    <Badge function='brand' px='padding.3' py='padding.1' height='s' display='flex' mx='auto' {...props}>
      {children}
    </Badge>
  )
}
export default Subtitle
